/*@flow*/
import React from 'react';
import createPortal from 'lib/createPortal';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';

type PopupT = Leaflet$Popup<>;
type PopupEventT = { popup: PopupT };

const onPopupClose = () => {};

function PopupPortal(props: DeckPropsT<*>): any | null {
  const { owner } = props;
  const [element, setElement] = useState();
  const [node, setNode] = useState();

  useEffect(() => {
    if (!owner) return;
    const onPopupOpen = ({ popup }: PopupEventT) => {
      const { component: Component, ...options } = popup.options;
      if (!Component) return;
      // Note: do not use `document.querySelector`. That seems to be
      // caching the node.
      const n = $(popup._container)
        .find('.pop-component')
        .get(0);

      setNode(n);
      setElement(() => (
        <Component options={options} latlng={popup.getLatLng()} />
      ));
    };

    owner.on('popupopen', onPopupOpen);
    owner.on('popupclose', onPopupClose);
    return () => {
      owner.off('popupopen', onPopupOpen);
      owner.off('popupclose', onPopupClose);
    };
  }, [owner]);

  return createPortal(element, node);
}

export default PopupPortal;
